<template>
  <div class="frame">
    <div v-if="linkExpired">
      <h1>{{ $t('gdpr.linkExpiredMessage') }}</h1>
      <a :href="helpcenterLink" v-on:click="redirectToHelpcenter">
        {{ $t('gdpr.backtoHcLinkText') }}
      </a>
    </div>
    <div class="w-100 mb20" style="text-align:left" v-if="!linkExpired">
      <h1 class="flex items-center flex-row">{{ $t('gdpr.title') }}</h1>
      <p class="fs12">{{ $t('gdpr.form2Description') }}</p>
      <p class="fs12">{{ $t('gdpr.form2Description2') }}</p>
      <p class="fs12">{{ $t('gdpr.form2Description3', [this.corpName]) }}</p>
      <p class="fs12">{{ $t('gdpr.form2Instructions') }}</p>
      <form id="gdpr" class="gdpr">
        <div class="flex flex-column w-100" role="alert">
          <p id="form-error" class="dark-red" v-if="errorMessage" v-html="errorMessage"></p>
          <p id="form-success" class="dark-green" v-if="successMessage">{{ $t('gdpr.successMessage') }}</p>
        </div>
        <hr />
        <div class="form-group">
          <label for="email">{{ $t('gdpr.dataSubjectEmailLabel') }}*:</label>
          <input type="email" name="email" id="email" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="email" :disabled="fixedEmail" /><span id="emailErr" class="error"></span>
          <p class="hint">{{ $t('gdpr.dataSubjectEmailDescription') }}</p>
          <label for="fullName">{{ $t('gdpr.dataSubjectFullNameLabel') }}:</label>
          <input type="text" id="fullName" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="fullName" />
          <span id="fullNameErr" class="error"></span>
        </div>
        <hr />
        <div class="form-group representative">
          <p>{{ $t('gdpr.isRepLabel', [this.siteName]) }}</p>
          <label>
            <input type="radio" name="isRep" value="no" aria-label="rep" v-model="isRep" />
            {{ $t('gdpr.subjectRadioButtonLabel') }}
          </label>
          <label>
            <input type="radio" name="isRep" value="yes" aria-label="dataSub" v-model="isRep" />
            {{ $t('gdpr.repRadioButtonLabel') }}
          </label>
          <span id="repErr" class="error"></span>
        </div>
        <div class="form-group" id="data-subject-section" v-if="isRep === 'yes'">
          <div class="form-group">
            <hr />
            <label for="data-subject-rep-name">{{ $t('gdpr.repNameLabel') }}:</label>
            <input type="text" name="dataSubjectRep" id="data-subject-rep-name" class="input ba h-35 br5 pa0 w-100" v-model="repName" />
            <span id="dataSubjectRepErr" class="error"></span>
          </div>
          <hr />
          <label for="declaration">
            <input type="checkbox" name="declaration" id="declaration" v-model="repDeclaration" />
            {{ $t('gdpr.repDeclarationLabel') }}
          </label>
        </div>
        <hr />
        <div class="form-group">
          <label for="acknowledgement">
            <input type="checkbox" name="acknowledgement" value="acknowledged" id="acknowledgement" v-model="subjectAcknowledgment" />
            {{ $t('gdpr.acknowledgementLabel') }}
          </label>
        </div>
        <button type="submit" class="h-35 br5 bg-blue white pointer bw0 fs16 w-50" id="submit" v-on:click="submitRequest" :disabled="!canSubmit">
          {{ $t('gdpr.submitButtonText') }}
        </button>
        <br />
        <div style="font-size: smaller; margin-top: 1em">
          {{ $t('gdpr.deletionTimeFrameText') }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { csbpApi, environment } from '@/config/index.js';
export default {
  name: 'GDPRDeletion',
  data() {
    return {
      siteId: undefined,
      siteName: undefined,
      domainName: undefined,
      corpName: undefined,
      language: undefined,
      email: undefined,
      fullName: undefined,
      isRep: 'no',
      repName: undefined,
      repDeclaration: undefined,
      subjectAcknowledgment: undefined,
      location: undefined,
      variation: '',
      memberId: undefined,
      ticketId: undefined,
      requesterId: undefined,
      sign: undefined,
      signt: undefined,
      targetOrigin: undefined,
      apiUrl: undefined,
      errorMessage: undefined,
      successMessage: false,
      isActive: true,
      fixedEmail: false,
      invalidSignature: false,
    };
  },
  computed: {
    helpcenterLink() {
      return environment === 'development' ? `http://localhost:8080/${this.language}` : `https://support.${this.domainName}/${this.language}`;
    },
    accountRecoveryLink() {
      return `http://members.${this.domainName}/account/recovery`;
    },
    linkExpired() {
      if (this.invalidSignature) {
        return true;
      }
      const expiredSignature = !this.signt || Number(this.signt) < Math.round(Date.now() / 1000) - 60 * 60 * 24;
      const expiredJWT = !this.jwtExp || this.jwtExp < Math.round(Date.now() / 1000);
      return this.invalidSignature || (expiredSignature && expiredJWT);
    },
    canSubmit() {
      return this.isActive && this.email?.length && this.subjectAcknowledgment && (this.isRep === 'no' || (this.repDeclaration && this.repName?.length));
    },
  },
  methods: {
    parseJwt(token) {
      // https://stackoverflow.com/a/38552302
      try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
        );
        return JSON.parse(jsonPayload);
      } catch (err) {
        return undefined;
      }
    },
    redirectToHelpcenter(e) {
      e.preventDefault();
      window.parent.postMessage(
        {
          type: 'redirect',
          url: this.helpcenterLink,
        },
        this.targetOrigin
      );
    },
    getVariables() {
      this.jwt = this.$route.query.data;
      const jwt = this.parseJwt(this.$route.query.data);
      this.email = jwt?.email ?? this.$route.query.email;
      this.memberId = jwt?.memberId ?? this.$route.query.mid;
      this.ticketId = jwt?.zendeskTicketId ?? this.$route.query.ticketId;
      this.jwtExp = jwt?.exp;

      this.siteId = this.$route.query.siteId ? this.$route.query.siteId : undefined;
      this.siteName = this.$route.query.siteName ? this.$route.query.siteName : undefined;
      this.domainName = this.$route.query.domainName ? this.$route.query.domainName : undefined;
      this.corpName = this.$route.query.corpName ? this.$route.query.corpName : undefined;
      this.language = this.$route.query.language ? this.$route.query.language : undefined;
      this.sign = this.$route.query._sign ? this.$route.query._sign : undefined;
      this.signt = this.$route.query._signt ? this.$route.query._signt : undefined;
      this.requesterId = this.$route.query.code ? this.$route.query.code : undefined;
      this.variation = this.$route.query.v ? this.$route.query.v : undefined;
      this.targetOrigin = this.domainName && environment !== 'development' ? `https://support.${this.domainName}` : 'http://localhost:8080';
      this.apiUrl = `${csbpApi}/gdpr/confirm`;
      if (this.email) {
        this.fixedEmail = true;
      }
    },
    syncIframeHeight() {
      if (document.body.scrollHeight !== window.innerHeight) {
        window.parent.postMessage(
          {
            type: 'resize',
            height: document.body.scrollHeight,
          },
          this.targetOrigin
        );
      }
    },
    async submitRequest(e) {
      e.preventDefault();
      this.isActive = false;
      this.errorMessage = '';
      this.successMessage = false;
      const request = {
        site_id: this.siteId,
        site_name: this.siteName,
        domain: this.domainName,
        lang: this.language,
        email: this.email,
        full_name: this.name,
        location: this.location,
        is_rep: this.isRep === 'yes' ? true : false,
        timestamp: Math.floor(Date.now() / 1000),
        rep_name: this.repName,
        sign: this.sign,
        signt: this.signt,
        member_id: this.memberId,
        ticket_id: this.ticketId,
        jwt: this.jwt,
      };
      try {
        const response = await fetch(this.apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(request),
        });
        const data = await response.json();
        if (data.success !== true) {
          if (data.message === 'Invalid Signature') {
            this.invalidSignature = true;
          } else {
            this.unsuccessfulHandler();
          }
        }
        if (data.success === true) {
          setTimeout(() => {
            window.parent.postMessage(
              {
                type: 'redirect',
                url: `${this.helpcenterLink}?request=success`,
              },
              this.targetOrigin
            );
          }, 5000);
          this.successMessage = true;
        }
      } catch (err) {
        this.unsuccessfulHandler();
      }
    },
    unsuccessfulHandler() {
      this.errorMessage = this.$t('gdpr.deletionFailureMessage');
      this.isActive = true;
    },
  },
  created() {
    this.getVariables();
    this.$i18n.locale = this.language;
    window.addEventListener('resize', () => {
      this.syncIframeHeight();
    });
  },
  mounted() {
    this.syncIframeHeight();
  },
  updated() {
    this.syncIframeHeight();
  },
  components: {},
};
</script>

<style scoped>
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.frame {
  background-color: #f7f4f4;
}

body {
  margin: 0;
  font-family: Roboto, Helvetica, Arial, sans-serif;
}

.form-group {
  margin-bottom: 1rem;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

#gdpr label {
  text-transform: capitalize;
  display: block;
  margin: 1em 0 0 0;
}

.bg-gray {
  background-color: #f7f4f4;
}

.bg-blue {
  background-color: #0072ef;
}

.logo {
  width: 43px;
  height: 50px;
}

.pa10 {
  padding: 5px;
}

.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.flex-row {
  flex-direction: row;
}

.justify-center {
  justify-content: center;
}

.items-center {
  align-items: center;
}

.w-25 {
  width: 25%;
}

.w-30 {
  width: 30%;
}

.w-50 {
  width: 50%;
}

.w-75 {
  width: 75%;
}

.w-80 {
  width: 80%;
}

.w-100 {
  width: 100%;
}

.h-35 {
  height: 35px;
}

.ma0 {
  margin: 0;
}

.mr10 {
  margin-right: 10px;
}

.mt20 {
  margin-top: 20px;
}

.mb5 {
  margin-bottom: 5px;
}

.mb10 {
  margin-bottom: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb30 {
  margin-bottom: 30px;
}

.bold {
  font-weight: 400;
}

.container {
  margin-right: auto;
  margin-left: auto;
  padding: 10px;
}

.input {
  margin: 0.5rem 0 0.2em 0;
  outline-color: rgb(64, 169, 243);
  border-color: rgb(204, 204, 204);
}

.ba {
  border-style: solid;
  border-width: 1px;
}

.br5 {
  border-radius: 5px;
}

.white {
  color: rgb(255, 255, 255);
}

.pointer {
  cursor: pointer;
}

.bw0 {
  border-width: 0;
}

.button:hover {
  background-color: #004189;
}

.pa0 {
  padding: 0;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}

.fs12 {
  font-size: 12px;
}

.fs14 {
  font-size: 14px;
}

.fs16 {
  font-size: 16px;
}

p[aria-hidden='true'] {
  opacity: 0;
}

p[aria-hidden='false'] {
  opacity: 1;
}

.h15 {
  height: 10px;
}

input[aria-invalid='true'] {
  border-color: red;
}

button[disabled],
button[disabled]:hover {
  background-color: rgb(221, 221, 221);
  cursor: not-allowed;
}

.dark-red {
  color: #e7040f;
}

.dark-green {
  color: #007728;
}

@media screen and (min-width: 768px) {
  .container {
    width: 75%;
  }

  .w-75-ns {
    width: 75%;
  }
}

@media screen and (min-width: 1440px) {
  .container {
    width: 50%;
  }

  .w-75-ns {
    width: 50%;
  }
}

hr {
  height: 2px;
  background-color: lightgray;
}

/* MODAL */
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 40px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/* MODAL */
/* LOADING MODAL */
.lds-ring {
  display: inline-block;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  width: 64px;
  height: 64px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* LOADING MODAL */
.modal-mask.nd,
.lds-ring.nd,
.nd {
  display: none;
}
</style>
